<template>
	<div>
		<div class="col-12 p-0 output-search rounded">
			<div class="col-12 p-0 border output-search-nohover rounded cus-box-shadow">
				<vcl :width="250" :height="300" :speed="2" primaryColor="#f3f3f3" secondaryColor="#ecebeb" >
					<rect x="30" y="20" rx="8" ry="8" width="200" height="200" />
					<rect x="70" y="240" rx="8" ry="8" width="120" height="20" />
					<rect x="40" y="270" rx="8" ry="8" width="180" height="20" />
				</vcl>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'SkeletonStockist',
}
</script>